import { atom } from "recoil";

const fleetAppointmentDetailsAtom = atom({

    key: "fleetAppointmentDetailsAtom",
    default: {}

});

export default fleetAppointmentDetailsAtom;